<template>
  <view>
    <cube-button bindclick="showPicker">slot-Picker</cube-button>
    <cube-cascade-picker-modal
      wx:ref="picker"
      title="标题"
      list="{{dataList}}"
      selected-index="{{selectedIndex}}"
    >
      <view slot="header" class="demo-slot-header-wrapper">
        <image class="demo-slot-header" src="https://ut-static.udache.com/webx/mpx-cube-ui/1GyZ1gVbkoNIDOtGNwyUh.jpg" style="background-size: 100%"></image>
      </view>
      <view slot="footer" class="demo-slot-footer" bindtap="clickCustomBtn">起点不在此机场</view>
    </cube-cascade-picker-modal>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      selectedIndex: [0, 1, 0],
      dataList: [{
        value: 'Fruit',
        text: 'Fruit',
        children: [{
          value: 'Apple',
          text: 'Apple',
          children: [{ value: 1, text: 'One' }, { value: 2, text: 'Two' }]
        }, {
          value: 'Orange',
          text: 'Orange',
          children: [{ value: 3, text: 'Three'}, { value: 4, text: 'Four' }]
        }]
      }, {
        value: 'Drink',
        text: 'Drink',
        children: [{
          value: 'Coffee',
          text: 'Coffee',
          children: [{ value: 1, text: 'One' }, { value: 2, text: 'Two' }]
        }, {
          value: 'Tea',
          text: 'Tea',
          children: [{ value: 1, text: 'One' }, { value: 3, text: 'Three'}]
        }]
      }]
    },
    methods: {
      showPicker() {
        this.confirmParams = '{ /* selectedIndex, selectedVal, selectedText */ }'
        this.valueChangeParams = '{ /* selectedIndex, selectedVal, selectedText */ }'
        this.$refs.picker.show()
      },
      clickCustomBtn() {
        this.$refs.picker.hide()
      }
    }
  })
</script>

<style lang="stylus" scoped>
.demo-slot-header-wrapper
  margin-bottom: 10px
  font-size: 0px
.demo-slot-header
  width 100%
  height 170px
.demo-slot-footer
  margin-top 15px
  text-align center
  font-size 16px
  color #757575
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-cascade-picker-modal": "@mpxjs/mpx-cube-ui/src/components/cascade-picker-modal/index"
    }
  }
</script>
